export const FAVORITE_SET   = 'FAVORITE_SET'
export const FAVORITE_UNSET = 'FAVORITE_UNSET'

export default {
  /**
   * Registra o actualiza el estado local de favorito de un ítem.
   */
  [FAVORITE_SET](state, { contentType, slug, value }) {
    const key = `${contentType}:${slug}`
    // Spread para que Vue detecte el cambio de referencia.
    state.favorites = { ...state.favorites, [key]: value }
  },

  /**
   * Elimina la entrada local (fallback al valor de la API en el próximo fetch).
   * Se usa en rollback cuando el ítem nunca había sido modificado localmente.
   */
  [FAVORITE_UNSET](state, { contentType, slug }) {
    const key = `${contentType}:${slug}`
    const rest = { ...state.favorites }
    delete rest[key]
    state.favorites = rest
  },
}
